// extracted by mini-css-extract-plugin
module.exports = {"gridFooter":"styles_gridFooter__fc5cS"};